import { Button, TextInput } from '@mantine/core';
import { modals } from '@mantine/modals';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useRequestPasswordResetForm } from 'src/Hooks/Forms/useRequestPasswordResetForm';
import { useRequestResetPassword } from 'src/Hooks/Mutations/useRequestResetPassword';

import styles from './ResetPasswordRequestForm.module.scss';

const ResetPasswordRequestForm = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const openInfoModal = useCallback(() => {
    modals.openContextModal({
      modal: 'info',
      title: t('auth.resetPassword.confirmModal.title', 'Changement demandé !'),
      centered: true,
      innerProps: {
        content: t(
          'auth.resetPassword.confirmModal.content',
          'Cliquez sur le lien dans le mail reçu.'
        ),
        confirmText: t('auth.resetPassword.confirmModal.close', 'Fermer'),
        onConfirm: () => navigate(-1),
      },
    });
  }, [navigate, t]);

  const { mutate, isLoading } = useRequestResetPassword({ onSuccess: () => openInfoModal() });

  const { form } = useRequestPasswordResetForm();

  return (
    <>
      <form
        onSubmit={form.onSubmit(values => mutate({ email: values.email }))}
        className={styles.container}
      >
        <div className={styles.title}>{t('auth.resetPassword.title', 'Mot de passe oublié')}</div>
        <div className={styles.subtitle}>
          {t(
            'auth.resetPassword.subtitle',
            'Entrez le mail associé à votre compte pour changer votre mot de passe'
          )}
        </div>
        <TextInput
          placeholder={t('auth.resetPassword.email', 'Mail du compte')}
          {...form.getInputProps('email')}
        />
        <Button type={'submit'} loading={isLoading}>
          {t('auth.resetPassword.requestNewPassword', 'Demander un nouveau mot de passe')}
        </Button>
      </form>
    </>
  );
};

export default ResetPasswordRequestForm;
